// @ts-nocheck

// middleware to allow or disable actions relatives to basket status
import { actionTypes, basketStatuses } from '../constants';

const { OK, EMPTY, PENDING, VALIDATED, WAITING_TRADER_VALIDATION, ERROR } = basketStatuses;
const {
  ADD_ITEM,
  SUBMIT,
  CLEAR_BASKET_ITEM,
  ACCEPT_CHANGE,
  ON_ERROR,
  ON_VALIDATED,
  ON_WAITING_TRADER_VALIDATION,
  SET_SELECTED_BET_GROUP,
  RESET_PANEL_CONTENT,
  ON_TRADER_NOTIFICATION,
  SET_DEFAULT_STAKE,
  SET_STAKE,
} = actionTypes;

const allowedActions = {
  [OK]: [CLEAR_BASKET_ITEM, SUBMIT, SET_STAKE, RESET_PANEL_CONTENT, SET_DEFAULT_STAKE, ACCEPT_CHANGE],
  [EMPTY]: [ADD_ITEM, SET_SELECTED_BET_GROUP, RESET_PANEL_CONTENT, SET_DEFAULT_STAKE],
  [PENDING]: [ON_ERROR, ON_VALIDATED, ON_WAITING_TRADER_VALIDATION, SET_DEFAULT_STAKE],
  [VALIDATED]: [CLEAR_BASKET_ITEM, SET_DEFAULT_STAKE, RESET_PANEL_CONTENT],
  [WAITING_TRADER_VALIDATION]: [ON_TRADER_NOTIFICATION, SET_DEFAULT_STAKE],
  [ERROR]: [CLEAR_BASKET_ITEM, SET_STAKE, SET_DEFAULT_STAKE, RESET_PANEL_CONTENT, ACCEPT_CHANGE, SUBMIT],
};

export default ({ getState }) =>
  (next) =>
  (action) => {
    if (action.type.match('^immersive/')) {
      const basketStatus = getState().immersive.status;
      const isActionAllowed = allowedActions[basketStatus].indexOf(action.type) !== -1;
      return isActionAllowed ? next(action) : null;
    }
    return next(action);
  };
